import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGImage from '../image-components/SVGImage.jsx';
import InteractableElement from '../InteractableElement.jsx';
import { isMobileDevice } from '../../../../store-components/utils/DeviceDetector';
const isMobile = isMobileDevice()
class SocialButton extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        const { onClickAnalytics, redirectUrl,copyLink } = this.props;
        console.log("big test");
        if (onClickAnalytics) {
            onClickAnalytics();
        }
        if(copyLink){
            const textField = document.createElement('textarea');
            textField.innerText = window.location.origin;
            document.body.appendChild(textField);
            textField.readOnly = true;  // Prevent iOS chrome from opening up keyboard

            const range = document.createRange();
            range.selectNode(textField);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand('copy');
            selection.removeAllRanges();
            textField.remove();
        }else{
        window.open(redirectUrl, '_blank');
        }
    }

    render() {
        const { imageSrc, color } = this.props;
        return (
            <span className='hoverable' style={this.props.style} onClick={isMobile ? console.log("im mobile"):this.onClick} onTouchEnd={this.onClick}>
                <SVGImage
                    className="inline"
                    src={imageSrc}
                    color={color}
                    width={22}
                    height={22}
                    viewbox='0 0 500 500'
                />
            </span>
        );
    }
}

SocialButton.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    style: Proptypes.object,
    redirectUrl: PropTypes.string.isRequired,
    imageColor: PropTypes.string,
    onClickAnalytics: PropTypes.func
};

export default SocialButton;
